import React from 'react';

const CandidateWhyChooseNew: React.FC = () => {
    return (
        <section className="relative px-4 pt-4 pb-4 sm:pt-10 sm:pb-10 overflow-x-hidden">
            {/* Desktop Layout - 1354px width with absolute positioning */}
            <div
                className="hidden lg:block"
                style={{
                    position: 'relative',
                    width: '1354px',
                    maxWidth: '100%',
                    height: '970px',
                    margin: '0 auto',
                }}
            >
                {/* Section Title */}
                <h2
                    style={{
                        position: 'absolute',
                        width: '1354px',
                        height: '350px',
                        left: '0',
                        top: '0',
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(48px, 8vw, 128px)',
                        lineHeight: 'clamp(60px, 10vw, 175px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                    }}
                >
                    Why candidates choose Hush
                </h2>

                {/* Card 1: Anonymity First - Small Card (Top Left) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '20px',
                        gap: '10px',
                        position: 'absolute',
                        width: '340px',
                        height: '274px',
                        left: '354px',
                        top: '382px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                    }}
                >
                    {/* Icon */}
                    <img
                        src="/career/anonymity.svg"
                        alt="Anonymity"
                        style={{
                            width: '136px',
                            height: '99px',
                            objectFit: 'contain',
                            flexShrink: 0,
                        }}
                    />

                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '300px',
                            height: '127px',
                            flex: 'none',
                            alignSelf: 'stretch',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '300px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Anonymity First
                            </h3>
                            <p
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Your profile remains private until you give us the green light to share it.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Card 2: Smarter Matches - Wide Card (Top Right) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        position: 'absolute',
                        width: '620px',
                        height: '274px',
                        left: '734px',
                        top: '382px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                        padding: '20px',
                    }}
                >
                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '580px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '580px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Smarter Matches
                            </h3>
                            <p
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                David, our AI recruiter learns from your feedback
                            </p>
                        </div>
                    </div>

                    {/* Icon and Description Below */}
                    <div style={{ display: 'flex', gap: '20px', marginTop: '16px', alignItems: 'flex-start' }}>
                        {/* Icon */}
                        <img
                            src="/career/smart_match.svg"
                            alt="Smart Match"
                            style={{
                                width: '136px',
                                height: '99px',
                                objectFit: 'contain',
                                flexShrink: 0,
                            }}
                        />

                        <p
                            style={{
                                width: '392px',
                                fontFamily: 'Inter',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                textAlign: 'justify',
                                color: 'rgba(255, 255, 255, 0.6)',
                                margin: 0,
                            }}
                        >
                            Hush's AI understands your career goals, skills, and preferences. Instead of generic job boards, you get highly relevant roles that fit your path and aspirations.
                        </p>
                    </div>
                </div>

                {/* Card 4: Less Effort, More Opportunity - Wide Card (Bottom Left) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        position: 'absolute',
                        width: '620px',
                        height: '274px',
                        left: '354px',
                        top: '696px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                        padding: '20px',
                    }}
                >
                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '580px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '580px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Less Effort, More Opportunity
                            </h3>
                            <p
                                style={{
                                    width: '580px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                No endless applications — let jobs come to you
                            </p>
                        </div>
                    </div>

                    {/* Icon and Description Below */}
                    <div style={{ display: 'flex', gap: '20px', marginTop: '16px', alignItems: 'flex-start' }}>
                        {/* Icon */}
                        <img
                            src="/career/opportunity.svg"
                            alt="Opportunity"
                            style={{
                                width: '136px',
                                height: '99px',
                                objectFit: 'contain',
                                flexShrink: 0,
                            }}
                        />

                        <p
                            style={{
                                width: '392px',
                                fontFamily: 'Inter',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                textAlign: 'justify',
                                color: 'rgba(255, 255, 255, 0.6)',
                                margin: 0,
                            }}
                        >
                            No endless applications or wasted effort. Hush actively finds and delivers opportunities, so you can focus on what matters. From better-fit roles to smarter introductions, the platform helps you move forward with confidence.
                        </p>
                    </div>
                </div>

                {/* Card 3: Built for your future - Small Card (Bottom Right) */}
                <div
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        padding: '20px',
                        gap: '10px',
                        position: 'absolute',
                        width: '340px',
                        height: '274px',
                        left: '1014px',
                        top: '696px',
                        background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.15)',
                        boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '40px',
                    }}
                >
                    {/* Icon */}
                    <img
                        src="/career/future.svg"
                        alt="Future"
                        style={{
                            width: '136px',
                            height: '99px',
                            objectFit: 'contain',
                            flexShrink: 0,
                        }}
                    />

                    {/* Content */}
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '16px 0px',
                            gap: '16px',
                            width: '300px',
                            height: '127px',
                            flex: 'none',
                            alignSelf: 'stretch',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                padding: '0px',
                                gap: '20px',
                                width: '300px',
                            }}
                        >
                            <h3
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '24px',
                                    lineHeight: '27px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: 0,
                                }}
                            >
                                Built for your future
                            </h3>
                            <p
                                style={{
                                    width: '300px',
                                    fontFamily: 'Inter',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Recruit proactively, ensure you are always one step ahead.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Layout - Stacked vertical cards */}
            <div className="lg:hidden max-w-[600px] mx-auto">
                {/* Section Title */}
                <h2
                    className="text-left mb-8"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(28px, 7vw, 128px)',
                        lineHeight: 'clamp(34px, 8vw, 175px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                    }}
                >
                    Why candidates choose Hush
                </h2>

                {/* Cards stacked vertically */}
                <div className="flex flex-col gap-6">
                    {/* Card 1: Anonymity First */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <img
                            src="/career/anonymity.svg"
                            alt="Anonymity"
                            style={{
                                width: '80px',
                                height: '60px',
                                objectFit: 'contain',
                            }}
                        />
                        <div>
                            <h3
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '24px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                Anonymity First
                            </h3>
                            <p
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Your profile remains private until you give us the green light to share it.
                            </p>
                        </div>
                    </div>

                    {/* Card 2: Smarter Matches */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <div>
                            <h3
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '24px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                Smarter Matches
                            </h3>
                            <p
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                David, our AI recruiter learns from your feedback
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%' }}>
                            <img
                                src="/career/smart_match.svg"
                                alt="Smart Match"
                                style={{
                                    width: '80px',
                                    height: '60px',
                                    objectFit: 'contain',
                                    flexShrink: 0,
                                }}
                            />
                            <p
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                    flex: 1,
                                }}
                            >
                                Hush's AI understands your career goals, skills, and preferences. Instead of generic job boards, you get highly relevant roles that fit your path and aspirations.
                            </p>
                        </div>
                    </div>

                    {/* Card 3: Less Effort, More Opportunity */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <div>
                            <h3
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '24px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                Less Effort, More Opportunity
                            </h3>
                            <p
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: '0 0 16px 0',
                                }}
                            >
                                No endless applications — let jobs come to you
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%' }}>
                            <img
                                src="/career/opportunity.svg"
                                alt="Opportunity"
                                style={{
                                    width: '80px',
                                    height: '60px',
                                    objectFit: 'contain',
                                    flexShrink: 0,
                                }}
                            />
                            <p
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                    flex: 1,
                                }}
                            >
                                No endless applications or wasted effort. Hush actively finds and delivers opportunities, so you can focus on what matters. From better-fit roles to smarter introductions, the platform helps you move forward with confidence.
                            </p>
                        </div>
                    </div>

                    {/* Card 4: Built for your future */}
                    <div
                        style={{
                            boxSizing: 'border-box',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: '20px',
                            gap: '16px',
                            background: 'radial-gradient(146.13% 118.42% at 50% -15.5%, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 99.59%), linear-gradient(180deg, rgba(46, 51, 90, 0) 0%, rgba(28, 27, 51, 0.1) 100%)',
                            border: '1px solid rgba(255, 255, 255, 0.15)',
                            boxShadow: 'inset 0px 0px 100px rgba(204, 215, 255, 0.15), 0px 5px 10px rgba(0, 0, 0, 0.05), 0px 15px 30px rgba(0, 0, 0, 0.05), 0px 30px 60px rgba(0, 0, 0, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '24px',
                        }}
                    >
                        <img
                            src="/career/future.svg"
                            alt="Future"
                            style={{
                                width: '80px',
                                height: '60px',
                                objectFit: 'contain',
                            }}
                        />
                        <div>
                            <h3
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 700,
                                    fontSize: '20px',
                                    lineHeight: '24px',
                                    color: '#FFFFFF',
                                    textShadow: '0px 0px 20px rgba(255, 255, 255, 0.5)',
                                    margin: '0 0 12px 0',
                                }}
                            >
                                Built for your future
                            </h3>
                            <p
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    margin: 0,
                                }}
                            >
                                Recruit proactively, ensure you are always one step ahead.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CandidateWhyChooseNew;
